import { defineMessage } from 'react-intl';

export const searchProductToProductsFallbackHeadline = defineMessage({
  id: 'rde.search-product-to-products.headline-fallback',
  defaultMessage: 'Ähnliche Artikel',
});
